/** @jsx jsx */
import { jsx } from '@emotion/react';
import { BooleanInput } from './BooleanInput';
import type { Props as BooleanInputProps } from './BooleanInput';

type Props = Omit<BooleanInputProps, 'type'>;

/**
 * <span style="color: #a81227; font-weight: bold;">⚠️ This component is on its way out in favor of [RadioGroup β](../?path=/docs/beta-radio--docs).</span>
 *
 * The `Radio` component is exposed for convenience and prefills the `type` prop to `radio`. An input element for choosing one option from a few predefined choices.
 *
 * `LabeledRadio` (and `LabeledBooleanInput)` wrap a `BooleanInput` with a `FormLabel` to render a full input and label combination.
 *
 * These components should be leveraged for most simple `BooleanInput` use cases where text renders beside the input since they define a focus state.
 */
export const Radio = ({ tabIndex = 0, ...otherProps }: Props) => (
  <BooleanInput type="radio" tabIndex={tabIndex} {...otherProps} />
);
